/* Constants */
import {
  PAGINATION_PARAM_NAMES,
  LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE,
} from './paginationConstants';
import {QUERY_STRING_PREFIX} from '../url/urlConstants';

/* Utils */
import {
  generateQueryString,
  generateSearchUrl,
  getHashValues,
  removeHashes,
} from '../url/urlUtils';

function canRedirectToFirstPage(queryParams) {
  return isFirstPage(queryParams[PAGINATION_PARAM_NAMES.PAGE]);
}

function isFirstPage(pageNumber) {
  let result;

  if (pageNumber) {
    result = pageNumber < 2;
  } else {
    result = true;
  }

  return result;
}

function goToInitialElementScrollPosition() {
  const locationHash = getHashValues(window.location.hash);

  if (locationHash && locationHash.sortId) {
    const clickedProductSortId = locationHash.sortId % LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE;
    const elementPositions = document.getElementById('productLink' + clickedProductSortId)?.getBoundingClientRect();
    const elementPositionTop = elementPositions.top;

    const scrollTimeout = setTimeout(() => {
      window.scrollTo(0, elementPositionTop);
      clearTimeout(scrollTimeout);
    }, 300);
  }

  removeHashes();
}

function generatePaginationPreviousButtonAnchorHref(pathname, queryParams, currentPageNumber, isCategoryPage, isSearchPage, isTagPage, isBrandPage) {
  let result;

  const FIRST_PAGE = 1

  // It adds page=1 to end of url. So it makes crawlers to index this page.
  // But we dont want them crawl this page. Pages are same as without parameter.
  const pageNumber = currentPageNumber - 1 !== FIRST_PAGE ? currentPageNumber - 1 : null

  if ((isCategoryPage && currentPageNumber) || (isTagPage && currentPageNumber) || (isBrandPage && currentPageNumber)) {
    result = pathname + generateQueryString({
      ...queryParams,
      [PAGINATION_PARAM_NAMES.PAGE]:  pageNumber,
    })
  } else if (isSearchPage && currentPageNumber) {
    result = pathname + QUERY_STRING_PREFIX + generateSearchUrl(generateQueryString(
      {
        ...queryParams,
        [PAGINATION_PARAM_NAMES.QUERY]: null,
        [PAGINATION_PARAM_NAMES.PAGE]: pageNumber,
      },
      {
        withPrefix: false,
        encode: false,
      },
    ), queryParams)
  }

  return result;
}

function generatePaginationNextButtonAnchorHref(pathname, queryParams, currentPageNumber, isCategoryPage, isSearchPage, isTagPage, isBrandPage) {
  let result;
  if ((isCategoryPage && currentPageNumber) || (isTagPage && currentPageNumber) || (isBrandPage && currentPageNumber)) {
    result = pathname + generateQueryString({
      ...queryParams,
      [PAGINATION_PARAM_NAMES.PAGE]: currentPageNumber + 1,
    })
  } else if (isSearchPage && currentPageNumber) {
    result = pathname + QUERY_STRING_PREFIX + generateSearchUrl(generateQueryString(
      {
        ...queryParams,
        [PAGINATION_PARAM_NAMES.QUERY]: null,
        [PAGINATION_PARAM_NAMES.PAGE]: currentPageNumber + 1,
      },
      {
        withPrefix: false,
        encode: false,
      },
    ), queryParams)
  }

  return result;
}

export {
  canRedirectToFirstPage,
  goToInitialElementScrollPosition,
  isFirstPage,
  generatePaginationNextButtonAnchorHref,
  generatePaginationPreviousButtonAnchorHref,

};
